<template>
  <div class="home">
    <fin-grid style="margin-bottom: 16px" :gap="16" :size="size">
      <fin-cell class="mygrid grid-12" :colSpan="6">
        <bff-card title="账号信息">
          <fin-grid :gap="10" :size="size">
            <fin-cell class="mygrid grid-12" :colSpan="12">
              <bffTextLabel leftText="所属组织" :rightText="companyName"></bffTextLabel>
            </fin-cell>
            <fin-cell class="mygrid grid-12" :colSpan="12">
              <bffTextLabel leftText="手机号" :rightText="$store.state.userInfo.phone" :isPhone="true"></bffTextLabel>
            </fin-cell>
          </fin-grid>
        </bff-card>
      </fin-cell>
      <fin-cell class="mygrid grid-12" :colSpan="6">
        <bff-card title="通知公告" :showMore="true" @click="goPage">
          <fin-grid :gap="10" :size="size">
            <fin-cell class="mygrid grid-12" :colSpan="12">
              <ul class="notice_wrap">
                <template v-for="item in notice">
                  <li :key="item.id" @click="goPage(item.id)">
                    <span>
                      <i class="notice_wrap_icon"></i>
                      {{ item.name }}
                    </span>
                    <span>{{ item.publishTime | timeDate('yyyy-MM-dd') }}</span>
                  </li>
                </template>
              </ul>
            </fin-cell>
          </fin-grid>
        </bff-card>
      </fin-cell>
    </fin-grid>

    <fin-grid :gap="10" :size="size" style="min-height: calc(100vh - 336px">
      <fin-cell class="mygrid grid-12" :colSpan="12">
        <bff-card title="数据概览" class="bff-card-box" bodyTitle="采购数据">
          <fin-grid :gap="10" :size="size">
            <bff-icon-label bgClass="order_yellow_2_bg" upText="待处理订单" :downText="content.pendingOrderCount"></bff-icon-label>
          </fin-grid>
          <bff-line></bff-line>
          <div class="bff_card_body_title">结算数据</div>
          <fin-grid :gap="10" :size="size">
            <fin-cell class="mygrid grid-12" :colSpan="2">
              <bff-icon-label bgClass="red_1" upText="待结算账单" :downText="content.unsettledPurchaseOrderCount"></bff-icon-label>
            </fin-cell>

            <fin-cell class="mygrid grid-12" :colSpan="2">
              <bff-icon-label bgClass="red_2" upText="待结算金额" :downText="content.unsettledOrderAmount"></bff-icon-label>
            </fin-cell>
          </fin-grid>
        </bff-card>
      </fin-cell>
    </fin-grid>
  </div>
</template>

<script>
import bffCard from './components/bffCard';
import bffTextLabel from './components/bffTextLabel.vue';
import bffLine from './components/bffLine.vue';
import bffIconLabel from './components/bffIconLabel.vue';
import { homeData, getCompaniesInfo, noticeList } from '@/utils/api';

export default {
  name: 'home',
  components: {
    bffCard,
    bffTextLabel,
    bffLine,
    bffIconLabel,
  },
  data() {
    return {
      size: 'large',
      companyName: '', //组织
      notice: [], //公告
      content: [], //
    };
  },

  methods: {
    // 首页数据
    getHomeData() {
      homeData()
        .then((res) => {
          this.content = res;
        })
        .catch((err) => {
          console.log('err:home', err);
        });
    },
    /*
     *@description:'跳转页面'
     */
    goPage(id) {
      if (id) {
        this.$router.push({ name: 'detailed', query: { id } });
        return;
      }
      this.$router.push({ name: 'list', query: {} });
    },
    /*
     *@description:'所属组织'
     */
    getCompany() {
      getCompaniesInfo()
        .then((res) => {
          this.companyName = res.companyName;
        })
        .catch((err) => {
          console.log('err:home', err);
        });
    },
    /*
     *@description:'获取公告'
     */
    getNotice() {
      noticeList()
        .then((res) => {
          this.notice = res.data;
        })
        .catch((err) => {
          console.log('err:home ', err);
        });
    },
  },
  mounted() {
    this.getHomeData();
    this.getCompany();
    this.getNotice();
  },
};
</script>
<style lang="scss" scoped>
::v-deep .fin-card {
  border: none;
}
.home {
  margin: 16px;
}
.box-card {
  height: 252px;
  margin-top: 15px;
}
.box-cente {
  /* margin-top: 20px; */
  height: 546px;
}
.box-small {
  width: 100%;
  height: 200px;
  display: flex;
}
.box-left {
  width: 373px;
  height: 200px;
  border-right: solid #eee thin;
}
.box-center {
  width: 100%;
  height: 200px;
}
.box-right {
  width: 334px;
  height: 200px;
  border-left: solid #eee thin;
}

.bff_card_body {
  height: 155px;
}

/* .bff_card_wrap.bff-card-box ::v-deep .fin-card {
  height: 710px !important;
} */
.bff_card_body_title {
  font-size: 16px;
  font-family: SourceHanSansCN;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);

  margin-bottom: 20px;
}
.notice_wrap {
  height: 100px;
  overflow: hidden;
}
.notice_wrap li {
  margin-bottom: 5px;

  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.notice_wrap li .notice_wrap_icon {
  display: inline-block;
  width: 4px;
  height: 4px;
  background: rgba(24, 144, 255, 0.3);
  opacity: 20;
  vertical-align: middle;
  border-radius: 50%;
  margin-right: 5px;
}
.notice_wrap li:first-of-type {
  color: $theme_color;
}
</style>
